import React, { useEffect, useContext } from "react";
import { ChatProvider } from "../../context/ChatContext";
import ChatPanel from "../chat-panel/ChatPanel";
import ChatSidebar from "../chat-sidebar/ChatSidebar";
import { UserContext } from "../../context/UserContext";
import { parseAuthFromUrl, authFetch, isAuthenticated, redirectToLogin } from "../../utils/auth";
import styles from "./Chat.module.css";

const Chat = () => {
  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    // Check for auth tokens in URL (after redirecting from Okta login)
    parseAuthFromUrl();
    
    // If not authenticated, redirect to login
    if (!isAuthenticated()) {
      redirectToLogin();
      return;
    }

    // Fetch user data with JWT auth
    authFetch("/api/user")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setUser(data);
      })
      .catch((error) => {
        console.error(
          "There has been a problem with user fetch operation:",
          error
        );
      });
  }, []);

  return (
    <div className={styles['chat-container']}>
      <ChatSidebar />
      <ChatProvider>
        <ChatPanel />
      </ChatProvider>
    </div>
  );
};
export default Chat;
